import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { CfgGstLedgersComponent } from '../cfg-gst-ledgers/cfg-gst-ledgers.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-account-reports',
  templateUrl: './account-reports.component.html',
  styleUrls: ['./account-reports.component.scss']
})
export class AccountReportsComponent implements OnInit {
  isWeb: boolean = true;
  right: any;
  jarvisData: any = [];
  isETally: boolean = false;
  destURL: string = "";
  destCRMURL: string = "";

  constructor(
    private router: Router, 
    private apiService: APIService,
    private modalService: NgbModal
  ) { }
  
  ngOnInit(): void {
    this.isWeb = this.apiService.apiCheckWeb();
    
    // Get user rights
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
    }

    // Fetch ETally bit
    let tblM = this.apiService.getCookie("M");
    if (tblM) {
      let mData = JSON.parse(tblM);
      if (mData.length > 0) {
        this.isETally = mData[0].ETally ? true : false;
      }
    }

    this.destURL = (this.apiService.fn_isLiveURL() ? "https://biziverse.com/" : "http://localhost:4200/") + "ERP/";
    this.destCRMURL = (this.apiService.fn_isLiveURL() ? "https://biziverse.com/" : "http://localhost:23533/") + "main.html";
  }

  reportArr: any = [{
    title: 'Accounts Indicators',
    titleColorCls: 'blueText',
    itemHeaderColorCls: 'orangeBkgd',
    reportItems: [
      {
        title: 'Balance Sheet',
        desc: 'Know your Assets & Liabilities',
        link: '',
        index: 1
      },
      {
        title: 'Profit & Loss',
        desc: 'Track your income levels',
        link: '',
        index: 2
      },
      {
        title: 'Trial Balance',
        desc: 'Get a quick overview',
        link: '',
        index: 3
      },
      {
        title: 'Day Book',
        desc: 'Track your daily transactions',
        link: '',
        index: 14
      }
    ]
  },
  {
    title: 'GST Reports',
    titleColorCls: 'blueText',
    itemHeaderColorCls: 'orangeBkgd',
    reportItems: [
      {
        title: 'Sales Summary',
        desc: 'Monthly summary of B2B, B2CS, B2CL sales',
        link: '',
        index: 4,
        class:'disabled-link',
        cursor:'not-allowed'
      },
      {
        title: 'HSN Analysis',
        desc: 'Classification of monthly sales',
        link: '',
        index: 5,
        class:'disabled-link',
        cursor:'not-allowed'
      },
      {
        title: 'GST Lists',
        desc: 'Quick access to sales & purchases',
        link: '',
        index: 6,
        class:'disabled-link',
        cursor:'not-allowed'
      },
      {
        title: 'GSTR 3B Calculation',
        desc: 'Summarize sales and purchases',
        link: '',
        index: 7
      },
    ]
  },
  {
    itemHeaderColorCls: 'orangeBkgd',
    reportItems: [
      {
        title: 'GSTR 2A Reconciliation',
        desc: 'Reconciliation of input credit claimed against shown by suppliers',
        link: '',
        index: 8,
        class:'disabled-link',
        cursor:'not-allowed'
      },
      {
        title: 'B2B Sales Summary',
        desc: 'Summary of Monthly B2B Sales',
        link: '',
        index: 9,
        class:'disabled-link',
        cursor:'not-allowed'
      },
      {
        title: 'B2CS Sales Summary',
        desc: 'Summary of Monthly B2C (Small) Sales',
        link: '',
        index: 10,
        class:'disabled-link',
        cursor:'not-allowed'
      },
      {
        title: 'B2CL Sales Summary',
        desc: 'Summary of Monthly B2C (Large) Sales',
        link: '',
        index: 11,
        class:'disabled-link',
        cursor:'not-allowed'
      }
    ]
  },
  {
    title: 'Sales Reports',
    titleColorCls: 'blueText',
    itemHeaderColorCls: 'orangeBkgd',
    reportItems: [
      {
        title: 'Purchase Sales Summary',
        desc: 'Summary of Daily Purchase',
        link: '',
        index: 12,
        class:'',
        cursor:''
      },
      {
        title: 'Daily Sales Summary',
        desc: 'Summary of Daily Sales',
        link: '',
        index: 13,
        class:'',
        cursor:''
      }
    ]
  },
  {
    title: 'Export',
    titleColorCls: 'blueText',
    itemHeaderColorCls: 'orangeBkgd',
    reportItems: [
      {
        title: 'Export to Tally',
        desc: 'Export Sales and Purchase invoices to Tally Prime',
        link: '',
        index: 16,
        class: '',
        cursor: ''
      }
    ]
  },
  {
    title: 'Configuration',
    titleColorCls: 'blueText',
    itemHeaderColorCls: 'orangeBkgd',
    isAcctsCfg: true,
    reportItems: [
      {
        title: 'GST Ledgers',
        desc: 'Configure GST ledgers',
        link: '',
        index: 15,
        class:'',
        cursor:''
      }
    ]
  }
  ]

  AccountReportsRedirect(index: number) {
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }


    let url: string = "";
    if (index == 1) {
      url = this.destURL + 'balanceSheet';
    }
    else if (index == 2) {
      url = this.destURL + 'profitandLoss';
    }
    else if (index == 3) {
      url = this.destURL + 'trialBalance';
    }
    else if (index == 4) {
      url = this.destURL + 'SalesSummary';
    }
    else if (index == 7) {
      url = this.destURL + 'GSTR3B';
    }
    else if (index == 9) {
      url = this.destURL + 'SalesSummary?TypeID=7';
    }
    else if (index == 10) {
      url = this.destURL + 'SalesSummary?TypeID=8';
    }
    else if (index == 11) {
      url = this.destURL + 'SalesSummary?TypeID=9';
    }
    else if (index == 12) {
      url = this.destCRMURL + '#/RptDailyPurchaseAnalysis';
    }
    else if (index == 13) {
      url = this.destCRMURL + '#/RptDailySalesAnalysis';
    }
    else if (index == 14) {
      url = this.destURL + 'DayBook';
    }
    else if (index == 15) {
      this.openGSTLedgerModal();
    }
    else if (index == 16) {
      if (this.isETally) {
        url = this.destCRMURL + '#/TallyExport';
      } else {
        this.apiService.errorAlert("This feature is not accessible");
      }
    }

    if (url != "") {
      window.open(url, target);
    }

    //window.open('TransactionHistory?XnTypeID=4',"_blank");

    // if (index == 4) {
    //   this.router.navigate(['/consumptionanalysis'])
    // }

    // if (index == 5) {
    //   this.router.navigate(['/materialusagetrend'])
    // }

    // if (index == 6) {
    //   this.router.navigate(['/suppliercomparison'])
    // }
    // if (index == 7) {
    //   this.router.navigate(['/consolidated-stock-transactions'])
    // }
    // if (index == 8) {
    //   this.router.navigate(['/transaction-history'])
    // }
    // if (index == 9) {
    //   this.router.navigate(['/stock-breakdown'])
    // }

    // if (index == 10) {
    //   this.router.navigate(['/purchasehistory'])
    // }

  }

  // openGSTLedgerModal() - Open GST Ledger configuration modal
  openGSTLedgerModal() {
    this.modalService.open(CfgGstLedgersComponent, { 
      windowClass: "gstSelectModal", 
      backdrop: 'static', 
      keyboard: false 
    });
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }
}
